import React from "react";

class Test extends React.Component {
  render() {
    return <img src={this.props.src} alt={""}/>;
  }
}

export default Test;
